import styled from "@emotion/styled";
import {Link as RemixLink} from "../../../elements/link";

export const Container = styled.div(({theme}) => ({
  width: "100%",
  gridColumn: theme?.breakpoints?.isMobile
    ? "1/-1"
    : theme?.breakpoints?.md
      ? "2/16"
      : "3/15",
  height: "100%",
  display: "grid",
  paddingBottom: 25,
  gridColumnGap: theme?.breakpoints?.isMobile ? 8 : 20,
  gridRowGap: theme?.breakpoints?.isMobile ? 8 : 20,
  gridTemplateColumns: theme?.breakpoints?.isMobile
    ? "repeat(4, 1fr)"
    : "repeat(12, 1fr)",
}));

export const Wrapper = styled.div(({theme}) => ({
  gridColumnGap: theme?.breakpoints?.isMobile ? 8 : 20,
  gridRowGap: theme?.breakpoints?.isMobile ? 8 : 20,
  gridTemplateColumns: theme?.breakpoints?.isMobile
    ? "repeat(4, 1fr)"
    : "repeat(12, 1fr)",
  gridColumn: theme?.breakpoints?.isMobile
    ? "1/-1"
    : theme?.breakpoints?.md
      ? "2/16"
      : "3/15",
  transition: "all 0.3s",
  margin: theme?.breakpoints?.isMobile ? "7px 0px 20px" : "20px 0px 20px",
}));
export const ImageContainer = styled.div(({theme}) => ({
  position: "relative",
  borderRadius: 8,
  display: "flex",
  overflow: "hidden",
  transition: "height 1.3s ease, box-shadow 0.3s ease",
  height: "auto",
  ":hover": {
    boxShadow: "0px 0px 32px 0px rgba(0, 0, 0, 0.2)",
  },
}));
export const ImageWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "span 2" : "span 3",
}));

export const Image = styled.img(({theme}) => ({
  borderRadius: 8,
  maxWidth: "100%",
  maxHeight: "100%",
  aspectRatio: theme?.breakpoints?.isMobile ? "16/9" : "23/12",
  objectFit: "cover",
}));

export const Button = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 4,
  height: 44,
  backgroundColor: "#27509B",
  paddingInline: 12,
});

export const ButtonContainer = styled.div(({theme, showAll}) => ({
  gridColumn: "1/-1",
  width: "fit-content",
  margin: "auto",
  marginTop: theme?.breakpoints?.isMobile && showAll ? 32 : showAll ? 40 : 20,
  transition: "all 0.3s",
  cursor: "pointer",
  ":hover": {
    boxShadow: "0px 6px 10px 0px #00000026",
  },
}));

export const Overlay = styled(RemixLink)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  borderRadius: 8,
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  opacity: 1,
}));
